export default __webpack_public_path__ + "9a5ce53864c792eb58b250c2ad3f1dae.svg";